__turbopack_context__.v({
  "content": "VideoPromo-module__Z_ur5G__content",
  "cta": "VideoPromo-module__Z_ur5G__cta",
  "layout": "VideoPromo-module__Z_ur5G__layout",
  "playIcon": "VideoPromo-module__Z_ur5G__playIcon",
  "text": "VideoPromo-module__Z_ur5G__text",
  "thumbnail": "VideoPromo-module__Z_ur5G__thumbnail",
  "title": "VideoPromo-module__Z_ur5G__title",
  "video": "VideoPromo-module__Z_ur5G__video",
});
